import { useCallback, useEffect, useState } from 'react'

const useFirstVisit = () => {
  const [firstVisit, setFirstVisit] = useState<boolean>(false)

  useEffect(() => {
    // const isFirstVisit = localStorage.getItem('firstVisit')
    // if (!isFirstVisit) {
    //   setFirstVisit(true)
    // }
    localStorage.setItem('tourCompleted', 'true')
    localStorage.setItem('firstVisit', 'true')
    // FIXME: return tour and fix it
  }, [])

  // useEffect(() => {
  //   const isFirstVisit = localStorage.getItem('firstVisit')
  //   const isVisitCompleted = isFirstVisit !== null && JSON.parse(isFirstVisit)
  //   if (isVisitCompleted) {
  //     localStorage.setItem('tourCompleted', 'true')
  //   }
  // }, [firstVisit])

  const firstVisitComplete = useCallback(() => {
    localStorage.setItem('firstVisit', 'true')
    setFirstVisit(false)
  }, [])

  return { firstVisit, firstVisitComplete }
}

export default useFirstVisit
